import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

import { postState } from '../../../store/postState';

console.log("FormPost");
export const FormPost = memo((props) => {
  const { staff_user, hospitals } = props;
  const [postData, setPostData] = useRecoilState(postState);
  const initialPostState = {
    hospital_id: '',
    content: '',
  }
  const [currentPost, setCurrentPost] = useState(initialPostState);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeData = (e) => {
    setCurrentPost({
      ...currentPost,
      [e.target.name]: e.target.value,
    })
  };

  const onChangeSelectData = (e) => {
    setCurrentPost({
      ...currentPost,
      hospital_id: e.value,
    });
  };

  const onClinicPostSubmit = () => {
    if (!currentPost.hospital_id || !currentPost.content) {
      alert("※医療機関と投稿内容は必須です。");
      return
    }

    var data = {
      posts: {
        hospital_id: parseInt(currentPost.hospital_id, 10),
        staff_users_id: staff_user,
        content: currentPost.content,
      }
    }

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/api/v1/posts`, data)
    .then(resp => {
      console.log("成功");
      console.log(resp.data);
      setPostData(resp.data);
      notify("success", "Post successfully created!");
      setCurrentPost({
        ...currentPost,
        content: '',
      });
    })
    .catch(e => {
      console.log(e.response);
      // alert(JSON.parse(e.request.responseText).errors);
      notify("error", "Post create Error!");
    })
  }

  console.log("currentPost");
  console.log(currentPost);
  return (
    <>
      <div className="card mt-2">
        <div className="card-body">
          <div className="row">
            <div className="col">
              <div className="input-group">
                <Select 
                  placeholder={"医療機関"}
                  className="hospital_id-width"
                  options={hospitals}
                  onChange={onChangeSelectData}
                />
                <input type="text" name="content" className="form-control w-50" id="tweet" value={currentPost.content} placeholder="投稿内容" onChange={onChangeData} />
                <button className="btn btn-secondary" type="button" onClick={onClinicPostSubmit} disabled={(!currentPost.hospital_id || !currentPost.content)}>
                  投稿
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});